import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useGTM } from '../../hooks/useGTM';
import { TrackingSchema } from '../../types';
import { Icon } from '../Icon';

export const SiteFooter: FC = () => {
  const { t } = useTranslation();

  const [inBriefing, setInBriefing] = useState(false);

  const location = useLocation();
  const { updateDataLayer } = useGTM();

  useEffect(() => {
    setInBriefing(location.pathname.includes('/briefing'));
  }, [location.pathname]);

  return (
    <footer
      className={`w-full text-gray-700 text-2xs flex-col xl:flex-row p-6 pr-0 md:pl-12 sticky flex-shrink-0 font-regular ${
        inBriefing ? 'hidden' : 'flex'
      }`}
    >
      <div className="flex flex-grow-0 flex-shrink-0 mb-4 md:mb-0">
        <a
          href={process.env.REACT_APP_CP_BASEURL}
          target="_blank"
          className="flex flex-shrink-0 hover:text-blue-100 focus:text-blue-100"
          rel="noopener noreferrer"
          onClick={() => {
            updateDataLayer({
              event: 'Content Click',
              schema: TrackingSchema.content,
              data: {
                category: 'Customer Portal',
                type: 'Customer Portal Redirect',
                content: 'Customer Portal Homepage',
              },
            });
          }}
        >
          <span className="w-4 mr-2">
            <Icon name="ExternalLink" />
          </span>
          <span>{t('components:footer:partOfAzelis')}</span>
        </a>
      </div>
      <div className="flex flex-col lg:flex-row">
        <p className="my-3 border-gray-500 md:my-4 xl:my-0 lg:border-r xl:border-l lg:pr-3 lg:mr-3 xl:px-5 xl:mx-5">
          {t('components:footer:copyright', { year: new Date().getFullYear() })}
        </p>
        <nav className="flex flex-col md:flex-row">
          <span className="flex flex-grow-0 flex-shrink-0 pr-3 my-3 md:my-0 lg:my-3 xl:my-0">
            <a
              href={`${process.env.REACT_APP_CP_BASEURL}/cookie-statement`}
              className="hover:text-blue-100 focus:text-blue-100"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                updateDataLayer({
                  event: 'Content Click',
                  schema: TrackingSchema.content,
                  data: {
                    category: 'Customer Portal',
                    type: 'Customer Portal Redirect',
                    content: 'Cookie statement',
                  },
                });
              }}
            >
              {t('components:footer:links:cookie')}
            </a>
          </span>
          <span className="flex flex-grow-0 flex-shrink-0 pr-3 my-3 md:my-0 lg:my-3 xl:my-0">
            <a
              href={`${process.env.REACT_APP_CP_BASEURL}/privacy-statement`}
              className="hover:text-blue-100 focus:text-blue-100"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                updateDataLayer({
                  event: 'Content Click',
                  schema: TrackingSchema.content,
                  data: {
                    category: 'Customer Portal',
                    type: 'Customer Portal Redirect',
                    content: 'Privacy Statement',
                  },
                });
              }}
            >
              {t('components:footer:links:privacy')}
            </a>
          </span>
          <span className="flex flex-grow-0 flex-shrink-0 pr-3 my-3 md:my-0 lg:my-3 xl:my-0">
            <a
              href={`${process.env.REACT_APP_CP_BASEURL}/terms-of-use`}
              className="hover:text-blue-100 focus:text-blue-100"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                updateDataLayer({
                  event: 'Content Click',
                  schema: TrackingSchema.content,
                  data: {
                    category: 'Customer Portal',
                    type: 'Customer Portal Redirect',
                    content: 'Terms & Conditions',
                  },
                });
              }}
            >
              {t('components:footer:links:terms')}
            </a>
          </span>
        </nav>
      </div>
    </footer>
  );
};
